<template>
  <Link
    :href="translatePath(ROUTES.CODE.HOME)"
    class="relative flex-shrink-0 inline-flex w-fit h-fit"
    :aria-label="$t('nav-home')"
  >
    <img
      :src="`/logo/${config.public.layoutDesign}-${variant}.svg`"
      :alt="$t('nav-home')"
      :width="width || logoHeader?.width || 126"
      :height="height || logoHeader?.height || 60"
      :class="className || logoHeader?.class || ''"
    >
  </Link>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { siteSettings } from "@settings/site.settings";
import Link from "@components/ui/link/link";


defineProps({
  variant: {
    type: String,
    default: 'black'
  },
  width: {
    type: Number,
    default: null
  },
  height: {
    type: Number,
    default: null
  },
  className: {
    type: String,
    default: ''
  }
});

const config = useRuntimeConfig();
const logoHeader = siteSettings.logo[config.public.layoutDesign]?.header;

</script>
